import React, { MutableRefObject } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { UploadCsvFileButton } from "./uploadCsvFileButton";
import { CsvInfoNotification, UploadCsvNotification } from "./notifications";
import {
  EnterManuallyButton,
  UploadFailButtons,
  UploadSuccessButtons,
} from "./csvActionButtons";
import { CsvFileInfo } from "./csvFileInfo";
import { addUrlsToList, clearCsvFile } from "../../urlFilters.actions";
import { getUploadUrlState } from "../../urlFilters.selectors";
import { EMPTY_CSV_ERROR } from "../../urlFilters.constants";

import "./UploadCsvBlock.scss";

interface UploadCsvBlockProps {
  toggleAddMethod: () => void;
  profileId: string;
  buttonRef: MutableRefObject<HTMLButtonElement>;
}

export const UploadCsvBlock = ({
  toggleAddMethod,
  profileId,
  buttonRef,
}: UploadCsvBlockProps) => {
  const dispatch = useDispatch();

  const { siteList, validation, isUploadFailed } =
    useSelector(getUploadUrlState);

  const isListEmpty = _.isEmpty(siteList);

  const addUrls = (list) => dispatch(addUrlsToList(list, siteList, profileId));
  const goBackToManualTyping = () => {
    toggleAddMethod();
    dispatch(clearCsvFile());
  };

  const uploadSuccess = !isListEmpty && !isUploadFailed;
  const uploadDefault = isListEmpty && !isUploadFailed;

  return (
    <div className="upload-csv">
      <div className="upload-csv__label">
        <FormattedMessage id="upload_csv" />
      </div>
      <div className="upload-csv__container">
        <UploadCsvFileButton buttonRef={buttonRef} />
        <div className="upload-csv__input-message">
          {uploadDefault ? (
            <span className="upload-csv__placeholder">
              <FormattedMessage id={"upload_one_file"} />
            </span>
          ) : (
            <CsvFileInfo />
          )}
        </div>
      </div>

      {validation.message && <ValidationMessages validation={validation} />}
      {uploadDefault && <CsvInfoNotification />}

      <div className="upload-csv__actions">
        {uploadDefault && (
          <EnterManuallyButton onToggleAddMethod={goBackToManualTyping} />
        )}

        {isUploadFailed && (
          <UploadFailButtons
            isEmptyCsv={validation.message === EMPTY_CSV_ERROR}
            onToggleAddMethod={goBackToManualTyping}
          />
        )}

        {uploadSuccess && <UploadSuccessButtons onAddUrls={addUrls} />}
      </div>
    </div>
  );
};

const ValidationMessages = ({
  validation: { type, message, messageValues, detailedMessages },
}) => (
  <UploadCsvNotification type={type}>
    <FormattedMessage id={message} values={messageValues} />
    {!_.isEmpty(detailedMessages) && (
      <ul className="urls-message-list">
        {_.map(detailedMessages, (messageItem, key) => {
          if (typeof messageItem === "object" && messageItem !== null) {
            return (
              <li className={"urls-message-list__complex-item"} key={key}>
                <FormattedMessage
                  id={messageItem.message}
                  values={messageItem.messageValues}
                />
              </li>
            );
          }

          return (
            <li className={"urls-message-list__item"} key={key}>
              {messageItem}
            </li>
          );
        })}
      </ul>
    )}
  </UploadCsvNotification>
);
